import { render, staticRenderFns } from "./FootPrintsLoading.vue?vue&type=template&id=68ae091a&"
import script from "./FootPrintsLoading.vue?vue&type=script&lang=js&"
export * from "./FootPrintsLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports